import { Map } from 'immutable'

import config from '../../../../config'
import { BUTTONSARRAY_KEY } from './components/Ribbon/constants'

import { createDataTableRegex, createFilterTableRegex, createListTableRegex } from '../helpers'

export const localeSelector = (state) => state.getIn(['translate', 'locale'])
export const sessionIdSelector = (state) => state.getIn(['authorization', 'sessionId'])
export const hasAccessRightsToReport = (state) =>
    state.getIn(['authorization', 'accessRights', config.modules.report.key, 'available'])
export const accessRightsLoadedSelector = (state) =>
    state.getIn(['authorization', 'accessRights', config.modules.report.key, 'isCustomLoaded'])
export const activeEntityReportId = (state) => {
    const activeTab = state.getIn(['ui', 'tabs', 'tabs']).find((tab) => tab.get('active')) || null

    return (activeTab && activeTab.get('id')) || null
}

export const getRibbonActiveBlocks = (state) => {
    const data = state.getIn(['ui', 'modules', config.modules.report.key, 'ribbon', BUTTONSARRAY_KEY, 'data'], Map())
    return data
        .filter((block) => block)
        .keySeq()
        .toList()
}

export const getReportActiveBlocksById = (state, id) => {
    const reportBlocks = state.getIn(['ui', 'modules', config.modules.report.key, 'workspace', id, 'blocks'], Map())
    const reportActiveBlocks = reportBlocks.filter((block) => block.get('active'))

    return reportActiveBlocks.keySeq().toList()
}

export const getToggleBlocksById = (state, id) => {
    const ribbon = getRibbonActiveBlocks(state).toSet()
    const report = getReportActiveBlocksById(state, id).toSet()

    return Map({
        toActive: ribbon.subtract(report).toList(),
        toInactive: report.subtract(ribbon).toList(),
    })
}

export const getDataTableIds = (state, id) => {
    const allIds = state.getIn(['tables', 'dataTable']).keySeq().toList()
    const regex = createDataTableRegex(config.modules.report.key, id)

    return allIds.filter((tableId) => regex.test(tableId))
}

export const getFilterTableIds = (state, id) => {
    const allIds = state.getIn(['tables', 'filterTable']).keySeq().toList()
    const regex = createFilterTableRegex(config.modules.report.key, id)

    return allIds.filter((tableId) => regex.test(tableId))
}

export const getListTableIds = (state, id) => {
    const allIds = state.getIn(['tables', 'listTable']).keySeq().toList()
    const regex = createListTableRegex(config.modules.report.key, id)

    return allIds.filter((tableId) => regex.test(tableId))
}

export const getTabsIds = (state, id) => {
    const allIds = state.get('tabs').keySeq().toList()
    const regex = new RegExp(`^${config.modules.report.key}_${id}.*$`)

    return allIds.filter((tabsId) => regex.test(tabsId))
}

export const getScrollbarsIds = (state, id) => {
    const allIds = state.get('scrollbar').keySeq().toList()
    const regex = new RegExp(`^${config.modules.report.key}_${id}.*$`)

    return allIds.filter((scrollbarId) => regex.test(scrollbarId))
}

export const isReportOpen = (state, id) =>
    !!state.getIn(['ui', 'modules', config.modules.report.key, 'workspace', id], null)

export const getAccessRightsReports = (state) =>
    state.getIn(['authorization', 'accessRights', config.modules.report.key, 'custom', 'reports'], Map())
